// Configuração comum a todos os provedores de tile.

// O Azure Static Web Apps responde com `Referrer-Policy: same-origin`, que apaga
// o Referer em toda requisição cross-origin — inclusive a dos tiles. Em produção
// os provedores recebiam as requisições sem identificação nenhuma, o que a
// política do OSM trata como motivo de bloqueio. Definir a policy no próprio
// <img> do tile corrige só as requisições de tile, sem afrouxar a policy do
// resto do site. Suportado pelo L.TileLayer desde o Leaflet 1.7.
export const TILE_REFERRER_POLICY = "strict-origin-when-cross-origin";
